import { TRANSLATIONS_ES_SHELL_AND_COMMON } from "./translations.es.shell-and-common";
import { TRANSLATIONS_ES_SETTINGS_CORE } from "./translations.es.settings-core";
import { TRANSLATIONS_ES_SETTINGS_GOOGLE } from "./translations.es.settings-google";
import { TRANSLATIONS_ES_SETTINGS_MICROSOFT } from "./translations.es.settings-microsoft";
import { TRANSLATIONS_ES_DOCUMENTS_AND_DRIVE } from "./translations.es.documents-and-drive";
import { TRANSLATIONS_ES_CHAT_TASKS_AND_PROFILE } from "./translations.es.chat-tasks-and-profile";
import { TRANSLATIONS_ES_DASHBOARD_AND_KNOWLEDGE } from "./translations.es.dashboard-and-knowledge";
import { TRANSLATIONS_ES_PLANS_AND_ADMIN } from "./translations.es.plans-and-admin";
import { TRANSLATIONS_ES_ONBOARDING } from "./translations.es.onboarding";
import { TRANSLATIONS_ES_GENERATION } from "./translations.es.generation";
import { TRANSLATIONS_ES_HOME_ACTIONS_AND_OVERVIEW } from "./translations.es.home-actions-and-overview";
import { TRANSLATIONS_ES_HOME_DECISION_DETAIL } from "./translations.es.home-decision-detail";
import { TRANSLATIONS_ES_HOME_QUEUE_AND_ACTIVITY } from "./translations.es.home-queue-and-activity";
import { TRANSLATIONS_ES_HOME_PULSE_AND_CALENDAR } from "./translations.es.home-pulse-and-calendar";
import { TRANSLATIONS_ES_HOME_QUALITY_AND_ALERTS } from "./translations.es.home-quality-and-alerts";

export const TRANSLATIONS_ES = {
  ...TRANSLATIONS_ES_SHELL_AND_COMMON,
  ...TRANSLATIONS_ES_SETTINGS_CORE,
  ...TRANSLATIONS_ES_SETTINGS_GOOGLE,
  ...TRANSLATIONS_ES_SETTINGS_MICROSOFT,
  ...TRANSLATIONS_ES_DOCUMENTS_AND_DRIVE,
  ...TRANSLATIONS_ES_CHAT_TASKS_AND_PROFILE,
  ...TRANSLATIONS_ES_DASHBOARD_AND_KNOWLEDGE,
  ...TRANSLATIONS_ES_PLANS_AND_ADMIN,
  ...TRANSLATIONS_ES_ONBOARDING,
  ...TRANSLATIONS_ES_GENERATION,
  ...TRANSLATIONS_ES_HOME_ACTIONS_AND_OVERVIEW,
  ...TRANSLATIONS_ES_HOME_DECISION_DETAIL,
  ...TRANSLATIONS_ES_HOME_QUEUE_AND_ACTIVITY,
  ...TRANSLATIONS_ES_HOME_PULSE_AND_CALENDAR,
  ...TRANSLATIONS_ES_HOME_QUALITY_AND_ALERTS,
};
